import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateVenueChannels } from 'src/api/updateVenueChannels';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { IFormValues } from 'src/components/VenueChannelsEditModal/types';
import { IVenue } from 'src/types/venue.types';
import { channelsPayload } from 'src/components/VenueChannelsEditModal/utilities';

export const useUpdateVenueChannels = (venue: IVenue, onMutationSuccess: () => void) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    ({ id, body }: { id: string; body: IFormValues }) => updateVenueChannels(id, channelsPayload(body.channels)),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: ['venue', venue.venueId] });
        showSnackbar({
          status: SnackbarStatus.SUCCESS,
          message: `You have successfully updated ${venue.name} venue.`,
        });
        onMutationSuccess();
      },
      onError: () => {
        showSnackbar({
          message: 'Something went wrong whilst updating a venue.',
          status: SnackbarStatus.ERROR,
        });
      },
    },
  );
};
